import {FileAddedIcon, FileIcon, FileMovedIcon, FileRemovedIcon} from '@primer/octicons-react'
import {Octicon} from '@primer/react'

import type {PatchStatus} from '@github-ui/diff-file-helpers'

export function FileStatusIcon({status}: {status: PatchStatus}): JSX.Element {
  switch (status) {
    case 'ADDED':
    case 'COPIED':
      return <Octicon size={16} icon={FileAddedIcon} sx={{color: 'success.fg'}} />
    case 'DELETED':
      return <Octicon size={16} icon={FileRemovedIcon} sx={{color: 'danger.fg'}} />
    case 'RENAMED':
      return <Octicon size={16} icon={FileMovedIcon} sx={{color: 'attention.fg'}} />
    default:
      return <Octicon size={16} icon={FileIcon} sx={{color: 'fg.muted'}} />
  }
}

try{ FileStatusIcon.displayName ||= 'FileStatusIcon' } catch {}